module.exports = __webpack_public_path__ + "static/img/ni.7b46e06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ni.png
// module id = Qp/I
// module chunks = 18